import AWS from 'aws-sdk';
import { userPool } from './../reducers/identity';
import configuration from './../configuration/server';
import store from './../configuration/store';
import { frontEndVersion, frontEndCommitHash } from './version';

/**
 * Checks if response code is in range of valid responses.
 * @param {number} status
 */
export const isOk = status => status >= 200 && status < 300;

export async function call({ path, method = methodTypes.GET, headers = {}, queryParams, body }) {
    body = body ? JSON.stringify(body) : body;
    headers[headerTypes.CONTENT_TYPE] = contentTypes.JSON;

    let role = getRole();
    if (role) {
        headers[headerTypes.ROLE] = Buffer.from(JSON.stringify(role)).toString('base64');
    }

    function queryParam(keyValArray) {
        const [key, val] = keyValArray;
        if (Array.isArray(val)) {
            return val.map(v => `${key}=${v}`).join('&');
        } else {
            return `${key}=${val}`;
        }
    }

    if (queryParams) {
        const query = Object.entries(queryParams)
            .map(k => queryParam(k))
            .join('&');
        path += `?${encodeURI(query)}`;
    }

    return authenticateUser()
        .then(token => (headers[headerTypes.AUTHORIZATION] = getToken(token)))
        .then(() =>
            fetch(configuration[configuration.STAGE].apiGateway.URL + path, {
                method,
                headers,
                body
            }).then(async response => {
                if (response.status === 204) {
                    return {};
                }

                const contentType = response.headers.get('content-type');
                let responseData = async () => {
                    if (contentType && contentType.indexOf(contentTypes.JSON) > -1) {
                        const data = await response.text();
                        return data ? JSON.parse(data) : data;
                    } else {
                        return response.text();
                    }
                };

                if (isOk(response.status)) {
                    return await responseData();
                }

                let error = await responseData();
                throw parseError(error);
            })
        );
}

function getToken(token) {
    if (!token) {
        throw new Error('User is not logged in');
    }
    return token;
}

export function getRole() {
    if (!store) return undefined;

    let state = store.getState();
    if (!state) return undefined;

    let { identity } = state;
    if (!identity || !identity.role) return undefined;

    let feVersion = frontEndVersion();
    let feHash = frontEndCommitHash();

    return {
        feVersion,
        feHash,
        role: identity.role.role,
        resource: identity.role.resource,
        resource_id: identity.role.resource_id
    };
}

export async function authenticateUser() {
    if (AWS.config && AWS.config.credentials && Date.now() < AWS.config.credentials.expireTime - 60000) {
        return true;
    }

    const currentUser = userPool.getCurrentUser();
    if (currentUser === null) {
        return false;
    }

    return await new Promise((resolve, reject) => {
        currentUser.getSession(function(err, session) {
            if (err) {
                reject(err);
                return;
            }
            resolve(session.getIdToken().getJwtToken());
        });
    });
}

export function parseError(error) {
    let defaultMessage = 'An error occurred!';
    if (!error) {
        return defaultMessage;
    }

    if (typeof error === 'string') {
        return error;
    }

    if (error.message) {
        return error.message;
    }

    return defaultMessage;
}

export const methodTypes = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE'
};

export const contentTypes = {
    JSON: 'application/json'
};

export const headerTypes = {
    CONTENT_TYPE: 'Content-Type',
    AUTHORIZATION: 'Authorization',
    ROLE: 'Role',
    FEVERSION: 'FEVersion'
};



// WEBPACK FOOTER //
// ./src/utilities/http.jsx